import '../../../css/components/pages/sign-in-to-portal.css';
import { Analytics } from '../../api/analytics';
import { Loc } from 'main.core';
import { SignInToPortalForm } from 'b24network.vue.sign-in-to-portal-form';
import { RoutePaths } from '../../routing/route-paths';

export const SignInToPortal = {
	name: 'SignInToPortal',

	components: {
		SignInToPortalForm,
	},

	methods: {
		onGoBackClick(): void
		{
			this.$router.replace(RoutePaths.SIGN_IN);
		},

		onIndicateB24AddressRedirect(): void
		{
			Analytics.emitRedirectLoginPopupBox();
		},
	},

	template: `
		<div class="b24net-island b24net-sign-in-to-portal">
			<div class="b24net-sign-in-to-portal__back-arrow-wrapper">
				<button
					type="button"
					class="b24net-sign-in-to-portal__back-button"
					aria-label="${Loc.getMessage('EXT_B24NET_SIGN_IN_TO_PORTAL_ARIA_BACK')}"
					@click="onGoBackClick"
				>
					<img
						src="/bitrix/templates/new_design_2024/images/icons/arrow-left.svg"
						alt=""
					/>
				</button>
			</div>
			<h2 class="b24net-island-title">${Loc.getMessage('EXT_B24NET_LOGGING_IN_TITLE')}</h2>

			<SignInToPortalForm @indicate-b24-address-redirect="onIndicateB24AddressRedirect"/>
		</div>
	`,
};
